/**
 * 呼叫中心-云群呼
 */
import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 轮呼列表
export const callRoundTaskList = (data: any) =>
  request.post('/call/cloudGroupCallTask/queryPage', data, jsonHeaderConfig)
// 初始化临时群呼任务
export const initcloudGroupCallTask = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/initial', data, jsonHeaderConfig)
// 获取支持群呼线路列表
export const groupCallLines = () => request.post('/call/line_support/group_call_lines', null)
// 根据线路筛选坐席组
export const selectSeatGroup = (data?: any) =>
  request.post('/call/call_center_seat_group/selectSeatGroup', data, jsonHeaderConfig)
// 群呼任务新建-参数校验
export const loudGroupCallTaskParamCheck = (data?: any) =>
  request.post('/call/cloudGroupCallTask/paramCheck', data, jsonHeaderConfig)

//--------------------------群呼20250805需求更改 start--------------------------------
// 群呼任务-公海、客户线索导入-查询指定条件客户
export const cloudGroupCallTaskHighSeaImportPreQueryCount = (data: any, headers: any) => {
  return request.post('/call/tempCloudGroupCallTask/importPreQueryCount', data, {
    headers: { ...jsonHeaderConfig.headers, ...headers }
  })
}

// 群呼任务-公海导入（创建任务时）
export const cloudGroupCallTemTaskHighSeaImport = (data: any, headers: any) =>
  request.post('/call/tempCloudGroupCallTask/orderImport', data, {
    headers: { ...jsonHeaderConfig.headers, ...headers }
  })
// 群呼任务-公海导入（编辑任务时）
export const cloudGroupCallTaskHighSeaImport = (data: any, headers: any) =>
  request.post('/call/cloudGroupCallTask/orderImport', data, {
    headers: { ...jsonHeaderConfig.headers, ...headers }
  })
//--------------------------群呼20250805需求更改 end--------------------------------

// 群呼公海导入进度
export const getCloudGroupCallImportProgress = (data?: any) =>
  request.post('/call/cloudGroupCallTask/getImportProgress', data)
// 群呼任务模板下载
export const cloudGroupCallTaskTemplate = '/call/tempCloudGroupCallTask/download_template'
// 群呼任务-创建任务时表格导入
export const cloudGroupCallTemplateTaskImportApi = (data: any) =>
  request.upload({
    url: '/call/tempCloudGroupCallTask/excelImport',
    data
  })

// 群呼任务-编辑任务时表格导入
export const cloudGroupCallTaskImportApi = (data: any) =>
  request.upload({
    url: '/call/cloudGroupCallTask/excelImport',
    data
  })
// 创建群呼任务
export const cloudGroupCallTaskSubmit = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/submit', data, jsonHeaderConfig)
// 云群呼-话损列表
export const queryLossCallDataPage = (data?: any) =>
  request.post('/call/cloudGroupCallContactInfo/queryLossCallDataPage', data, jsonHeaderConfig)
// 接入通话时查询联系人信息
export const getCallingCustomerInfo = (data?: any) =>
  request.post('/call/cloudGroupCallContactInfo/callingCustomerInfo', data, jsonHeaderConfig)
// 查询线路阈值
export const checkOrganThreshold = (data?: any) =>
  request.post('/call/cloudGroupCallTask/checkOrganThreshold', data)
// 间隔上报坐席
export const heartBeatReport = (data: any) =>
  request.post('/call/seat_status_manager/heart_beat_report', data, jsonHeaderConfig)
// 群呼-删除临时客户(创建任务时)
export const deleteContactTempApi = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/delTempData', data)
// 群呼-删除临时客户（编辑任务时）
export const deleteContactApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/deleteContact', data, jsonHeaderConfig)
// 群呼-查询临时任务客户数据(创建任务时)
export const queryTempDataPageApi = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/queryTempDataPage', data, jsonHeaderConfig)
// 群呼-查询临时任务客户数据(编辑任务时)
export const queryContactPageApi = (data?: any) =>
  request.post('/call/cloudGroupCallContactInfo/queryContactPage', data, jsonHeaderConfig)
// 群呼-提交任务进度
export const submitProgressApi = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/submitProgress', data, jsonHeaderConfig)
// 群呼-运行任务
export const runnableTaskApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/runnable', data)
// 群呼-暂停任务
export const pauseTaskApi = (data?: any) => request.post('/call/cloudGroupCallTask/pause', data)
// 群呼-删除任务
export const deleteTaskApi = (data?: any) => request.post('/call/cloudGroupCallTask/delete', data)
// 群呼-提交编辑
export const submitEditApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/submitEdit', data, jsonHeaderConfig)
// 群呼-点击编辑按钮时的处理
export const touchEditBtnApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/touchEditBtn', data)
// 群呼-任务数据预览
export const taskPreviewApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/taskPreview', data)
// 查看群呼任务-任务详情
export const getTaskDetailApi = (data?: any) =>
  request.post('/call/cloudGroupCallContactInfo/queryPage', data, jsonHeaderConfig)
// 关联saas客单
export const correlationShopOrder = (data: any) =>
  request.post('/call/cloudGroupCallContactInfo/correlation_shop_order', data, jsonHeaderConfig)
// 客户关联处理回调
export const processed = (data: any) =>
  request.post('/call/cloudGroupCallContactInfo/processed', data, jsonHeaderConfig)
// 更新基础配置
export const baseConfUpdateApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/baseConfUpdate', data, jsonHeaderConfig)
// 坐席组详情
export const seatGroupDetailApi = (data?: any) =>
  request.post('/call/call_center_seat_group/details', data, jsonHeaderConfig)
// 查询任务已呼数
export const selectCalledCountApi = (data?: any) =>
  request.post('/call/cloudGroupCallStatistics/selectCalledCount', data, jsonHeaderConfig)
// 更新联系人-编辑任务时
export const updateContactApi = (data?: any) =>
  request.post('/call/cloudGroupCallTask/updateContact', data, jsonHeaderConfig)
// 更新联系人-创建任务时
export const updateContactTempApi = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/editContact', data, jsonHeaderConfig)
// 群呼任务-下载导入结果接口
export const cloudGroupCallTaskdownloadFailResult =
  '/call/tempCloudGroupCallTask/downloadFailResult'
// 取消新建任务
export const cancelCreateTaskApi = (data?: any) =>
  request.post('/call/tempCloudGroupCallTask/cancel', data)
// 客户池校验接口
export const checkOrderPool = (data: any) =>
  request.post('/call/cloudGroupCallContactInfo/checkOrderPool', data, jsonHeaderConfig)
// 新建/编辑任务-取消导入接口
export const deleteUnSubmitDataApi = (data: any) =>
  request.post('/call/cloudGroupCallTask/deleteUnSubmitData', data)
// 群呼任务详情-导出
export const exportContactDetailApi = '/call/cloudGroupCallContactInfo/exportContactDetail'
// 有效坐席树-通过群呼任务查询绑定坐席组下的坐席成员
export const queryUserTreeBySeatGroupApi = (data: any) =>
  request.post('/call/cloudGroupCallTask/queryUserTreeBySeatGroup', data, jsonHeaderConfig)
